/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 * Migrated from: lego/constants/SaveFilterType.js
 */

export enum SaveFilterType {
  ACTIVITY = 'ACTIVITY',
  CLINICAL = 'CLINICAL',
  ETMF = 'ETMF',
  ACCESS_RIGHTS = 'ACCESS_RIGHTS',
  READ_AND_ACKNOWLEDGE = 'READ_AND_ACKNOWLEDGE',
  REJECT = 'REJECT',
  USER = 'USER2',
  GROUP = 'GROUP',
  CHANGE_REQUEST = 'CHANGE_REQUEST',
  CHANGE_REQUEST_TYPES = 'CHANGE_REQUEST_TYPES',
  PROPERTIES_SEARCH = 'PROPERTIES_SEARCH',
  ETMF_COMPLETION_RATE = 'ETMF_COMPLETION_RATE',
  ETMF_DOCUMENT_DETAIL = 'ETMF_DOCUMENT_DETAIL',
  ETMF_FINAL_DOCS = 'ETMF_FINAL_DOCS',
  ETMF_CONTRIBUTOR_DOC_STATUS = 'ETMF_CONTRIBUTOR_DOC_STATUS',
  PROPERTIES_USAGE = 'PROPERTIES_USAGE',
  EOS_DOWNLOAD_ACTIVITY = 'EOS_DOWNLOAD_ACTIVITY',
  EOS_ACKNOWLEDGEMENT_ACTIVITY = 'EOS_ACKNOWLEDGEMENT_ACTIVITY',
  EOS_WORKFLOWS = 'EOS_WORKFLOWS',
  TASK = 'TASK',
  DOCUMENT_EXPIRED = 'DOCUMENT_EXPIRED',
  CUSTOM = 'CUSTOM',
  SEARCH = 'SEARCH',
  EOS_WORKFLOWS_REQUESTS = 'EOS_WORKFLOWS_REQUESTS',
  DUPLICATE_DOCUMENTS = 'DUPLICATE_DOCS',
  QC_REVIEW = 'QC_REVIEW',
  ETMF_TIMELINESS = 'ETMF_TIMELINESS'
}

export type SaveFilterTypeValue = (typeof SaveFilterType)[keyof typeof SaveFilterType]
